(function () {
  'use strict';

  angular
    .module('MktzapApp.Controllers')
    .requires
    .push(
      'ngTable'
      , 'chart.js'
    );

  angular.module('MktzapApp.Controllers')
    .controller('ReportsTransactionAccountingController', reports);

  reports.$inject = ['$scope', '$http', 'NotificationService', 'LangService'];

  function reports ($scope, $http, NotificationService, LangService) {
    var vm = this;
    $scope.vm = vm;
    vm.loading = false;
    vm.exportAs = 'csv';
    vm.status = [];

    vm.filters = {
      fromDate: moment().startOf('month').format('DD/MM/YYYY'),
      toDate: moment().endOf('month').format('DD/MM/YYYY')
    };

    LangService
      .getPageLabels({ 'page': 'menu.reports.transactionAccounting' })
      .$promise
      .then(function (data) {
        vm.labels = data.lang;
      });

    vm.dateSelected = function (type, date) {
      if (type == 'from') {
        vm.pkadayToDate.setMinDate(date);
      }
      if (type == 'to') {
        vm.pkadayFromDate.setMaxDate(date);
      }
    };

    vm.download = function (downloadReport) {
      $http.get(apiUrl + '/reports/transaction_accounting', {
        params: {
          filters: vm.filters,
          downloadReport: downloadReport,
          reportType: 'TransactionAccounting'
        }
      })
        .then(function ({ data, status, headers, config }) {
          vm.loading = false;
          if (data) {
            if (data.success === false) {
              NotificationService.errorHandler(data, vm.labels.errorReport);
              return;
            }
            if (data.warning) {
              NotificationService.errorHandler(data, vm.labels.errorData);
              return;
            }
            var filename = headers('Mktzap-Filename') || 'transaction_accounting' + '.csv';

            var anchor = angular.element('<a/>');
            anchor.css({ display: 'none' }); // Make sure it's not visible
            angular.element(document.body).append(anchor); // Attach to document

            var blob = new Blob([data], { type: headers('Content-type') });
            var csvUrl = URL.createObjectURL(blob);

            anchor.attr({
              href: csvUrl,
              target: '_self',
              download: filename
            })[0].click();

            anchor.remove(); // Clean it up afterwards
            URL.revokeObjectURL(csvUrl); // Clean memory blob
          }
        }, function ({ data, status, headers, config }) {
          NotificationService.errorHandler(data, vm.labels.errorReport);
        })
    };
  }
})();
